import { Outlet } from 'react-router-dom';
import Footer from './footer/Footer';
import Navigation from './navigation/Navigation';

const Layout = () => (
  <>
    <Navigation />
    <Outlet />
    <Footer
      columns={[
        // TODO: Change links!!
        {
          id: 1,
          title: 'Spona',
          links: [
            {
              id: '1.1',
              title: 'About us',
              link: 'about-us',
            },
            {
              id: '1.2',
              title: 'Careers',
              link: 'work-with-us',
            },
            {
              id: '4.2',
              title: 'Contact',
              link: 'contact-us',
            },
            // {
            //   id: '1.3',
            //   title: 'Success stories',
            //   link: '/case-study-archive',
            // },
            // {
            //   id: '1.4',
            //   title: 'Spona Media',
            //   link: 'spona-media',
            // },
          ],
        },
        {
          id: 2,
          title: 'Solutions',
          links: [
            {
              id: '2.1',
              title: 'Hire',
              link: 'how-to-hire',
            },
            {
              id: '2.2',
              title: 'Offer Services',
              link: 'how-to-find-work',
            },
            {
              id: '2.3',
              title: 'Management Tool',
              link: 'how-to-manage-buyer',
            },
            {
              id: '2.4',
              title: 'Spona Performance',
              link: 'spona-media',
            },
            {
              id: '2.5',
              title: 'Pricing',
              link: 'pricing',
            },
            // FIXME: commented out for version 1
            // {
            //   title: 'Enterprise',
            //   link: 'enterprise',
            // },
          ],
        },
        {
          id: 3,
          title: 'Resources',
          links: [
            {
              id: '3.1',
              title: 'Client Success Stories',
              link: 'case-study-archive',
            },
            {
              id: '3.2',
              title: 'Blog/News & Updates',
              link: 'blog-archive',
            },
            // {
            //   id: '3.3',
            //   title: 'Pricing',
            //   link: 'how-to-manage-seller/pricing',
            // },
          ],
        },
        {
          id: 4,
          title: 'Legal & Policies',
          links: [
            // FIXME: commented out for version 1
            // {
            //   title: 'FAQs',
            //   link: '/faq',
            // },
            {
              id: '4.1',
              title: 'Terms of Service',
              link: 'terms-of-service',
            },
            {
              id: '4.2',
              title: 'Cookies Policy',
              link: 'terms-of-service/cookie-policy',
            },
          ],
        },
      ]}
    />
  </>
);

export default Layout;
